module.exports = __webpack_public_path__ + "static/img/popcorn.93ac56d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-img/png-img/popcorn.png
// module id = 1177
// module chunks = 173